import React from "react";
import Footer from "../templates/Footer";
import HeaderPortfolio from "../templates/portfolio/HeaderPortfolio";

const LayoutPortfolio = (props) => {
	return (
		<>
			<HeaderPortfolio />
			{props.children}
			<Footer />
		</>
	);
};

export default LayoutPortfolio;
